import { render, staticRenderFns } from "./ButtonFloatWhatsapp.vue?vue&type=template&id=162e8da9&scoped=true"
import script from "./ButtonFloatWhatsapp.vue?vue&type=script&lang=js"
export * from "./ButtonFloatWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./ButtonFloatWhatsapp.vue?vue&type=style&index=0&id=162e8da9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162e8da9",
  null
  
)

export default component.exports